__turbopack_context__.v({
  "cardCaption": "HoverTip-module__wEpr3q__cardCaption",
  "cardHead": "HoverTip-module__wEpr3q__cardHead",
  "cardHeadIcon": "HoverTip-module__wEpr3q__cardHeadIcon",
  "cardHeadIconEscudo": "HoverTip-module__wEpr3q__cardHeadIconEscudo",
  "cardHeadText": "HoverTip-module__wEpr3q__cardHeadText",
  "cardRow": "HoverTip-module__wEpr3q__cardRow",
  "cardRowIcon": "HoverTip-module__wEpr3q__cardRowIcon",
  "cardRowLabel": "HoverTip-module__wEpr3q__cardRowLabel",
  "cardRowValues": "HoverTip-module__wEpr3q__cardRowValues",
  "cardRows": "HoverTip-module__wEpr3q__cardRows",
  "cardSep": "HoverTip-module__wEpr3q__cardSep",
  "cardTitle": "HoverTip-module__wEpr3q__cardTitle",
  "cardUnaLinea": "HoverTip-module__wEpr3q__cardUnaLinea",
  "cardValue": "HoverTip-module__wEpr3q__cardValue",
  "cardValueDetail": "HoverTip-module__wEpr3q__cardValueDetail",
  "cardValueText": "HoverTip-module__wEpr3q__cardValueText",
  "tip": "HoverTip-module__wEpr3q__tip",
  "tipCard": "HoverTip-module__wEpr3q__tipCard",
  "tipDetail": "HoverTip-module__wEpr3q__tipDetail",
  "tipIn": "HoverTip-module__wEpr3q__tipIn",
  "tipLeft": "HoverTip-module__wEpr3q__tipLeft",
  "tipRight": "HoverTip-module__wEpr3q__tipRight",
  "tipTitle": "HoverTip-module__wEpr3q__tipTitle",
  "tipTouch": "HoverTip-module__wEpr3q__tipTouch",
  "tipWrap": "HoverTip-module__wEpr3q__tipWrap",
});
